import React from 'react';
import { TextField, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentUser } from '../../utils/auth';
import { FormattedMessage } from 'react-intl';
import { Autocomplete } from '@material-ui/lab';
import { useGetContactGroups } from '../../queries/queryContactGroups';

/**
 * Receive the MuiSelector props
 * @param props
 * @param currentUser
 * @returns {JSX.Element}
 * @constructor
 */

const ContactGroupSelectorComponent = ({ currentUser, onChange, value: group, ...props }) => {
  const { data: groups = [], isLoading, isFetching } = useGetContactGroups({
    clientId: currentUser.client_id
  });

  const labelUI = (
    <Typography>
      <FormattedMessage id="group.chooseGroup" />
      <Typography component="span">
        <i>*</i>
      </Typography>
    </Typography>
  );

  return (
    <Autocomplete
      options={groups}
      getOptionLabel={option => (typeof option === 'string' ? '' : option.name)}
      getOptionSelected={(option, value) => value === '' || option.id === value.id}
      onChange={(_, value) => onChange && onChange(value)}
      renderInput={params => <TextField label={labelUI} {...params} />}
      value={groups.find(x => group && x.id === group.id) || ''}
      disabled={props.disabled || isLoading || isFetching}
      {...props}
    />
  );
};

ContactGroupSelectorComponent.propTypes = {
  clientId: PropTypes.number,
  disabled: PropTypes.bool,
  currentUser: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object
};

const mapToProps = state => ({ currentUser: getCurrentUser(state) });

export const ContactGroupSelector = connect(mapToProps)(ContactGroupSelectorComponent);
